const getPrintfulNavigation = (t, { isAdmin = false } = {}) => [
  { to: "/dropshipping/platforms", label: t("h_pf_nav_all", "Platforms") },
  { to: "/dropshipping/printful", label: t("h_pf_nav_printful", "Printful") },
  { to: "/dropshipping/printful/connect", label: t("h_pf_nav_connect", "Connection") },
  { to: "/dropshipping/printful/suppliers", label: t("h_pf_nav_suppliers", "Suppliers") },
  { to: "/dropshipping/printful/products", label: t("h_pf_nav_products", "Products") },
  { to: "/dropshipping/printful/imported", label: t("h_pf_nav_imported", "Imported") },
  { to: "/dropshipping/printful/orders", label: t("h_pf_nav_orders", "Orders") },
  { to: "/dropshipping/printful/errors", label: t("h_pf_nav_errors", "API Errors") },
  ...(isAdmin ? [{ to: "/dropshipping/printful/admin", label: t("h_pf_nav_admin", "Administration") }] : []),
];
module.exports = { getPrintfulNavigation };
